/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ExperimentsExperimentIdRouteImport } from './routes/experiments/$experimentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsExperimentIdRoute = ExperimentsExperimentIdRouteImport.update({
  id: '/experiments/$experimentId',
  path: '/experiments/$experimentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/experiments/$experimentId': typeof ExperimentsExperimentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/experiments/$experimentId': typeof ExperimentsExperimentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/experiments/$experimentId': typeof ExperimentsExperimentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/experiments/$experimentId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/experiments/$experimentId'
  id: '__root__' | '/' | '/experiments/$experimentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ExperimentsExperimentIdRoute: typeof ExperimentsExperimentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/$experimentId': {
      id: '/experiments/$experimentId'
      path: '/experiments/$experimentId'
      fullPath: '/experiments/$experimentId'
      preLoaderRoute: typeof ExperimentsExperimentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ExperimentsExperimentIdRoute: ExperimentsExperimentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
